import { associationKit } from './association-kit';
import { callKit } from './call-kit';
import { peerKit } from './peer-kit';
import { takeoverKit } from './takeover-kit';
import { displayshareKit } from './displayshare-kit';
import { displaydemoKit } from './displaydemo-kit';

export const kits = [
  callKit,
  takeoverKit,
  peerKit,
  associationKit,
  displayshareKit,
  displaydemoKit,
] as const;
